import { Button, Card, Grid, TextField, Typography } from '@mui/material';
import { deleteObjectApi, getObjectListByPropertyApi, postSaveObjectApi, putUpdateObjectApi } from 'api/general';
import { chunkData, getSubjectName, highlightText, stripHTMLTags } from 'app/utils/appHelpers';
import { CRON_DATA, VOTE } from 'app/utils/constants/customConstant';
import { dshCardHeight } from 'config';
import { redColor } from 'app/themes/main/default';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showAgendaSnackbar } from 'stores/meeting';
import DshBoxTitle from '../Box/DshBoxTitle';
import ReviewFileListTable from '../Table/ReviewFileListTable';
import { controlOfAllUserInputs } from 'api/meeting';

function AddUpdateVoteCard({ decision, index, addAfterTable, updateAfterTable, handleDelete, setVoteInputStatus, voteOfTheUser, highlightQuery, decisionFiles }) {

  const dispatch = useDispatch();
  const { authUser } = useSelector(state => state.auth);
  const initialVote = voteOfTheUser?.vote;
  const [acceptButtonText, setAcceptButtonText] = useState(initialVote === 1 ? "Kabul ettiniz" : "Kabul");
  const [rejectButtonText, setRejectButtonText] = useState(initialVote === 2 ? "Reddettiniz" : "Ret");
  const subjectList = useSelector(state => state.subject.data || []);
  const currentMeeting = useSelector((state) => state.meeting.currentMeeting);
  const [isDeleteButtonVisible, setIsDeleteButtonVisible] = useState(!!voteOfTheUser?.id);
  const userList = useSelector(state => state.user.data || []);

  const emptyVote = {
    userId: authUser.id,
    meetingId: currentMeeting.id,
    decisionId: decision.id,
    inst: authUser.inst,
    vote: 0,
    info: '',
    pdate: new Date()
  };

  const [vote, setVote] = useState(voteOfTheUser === undefined ? emptyVote : voteOfTheUser);

  const filedata = (decisionFiles || []).filter(item => item.decisionId === decision.id);
  const agendaFileList = filedata.filter(item => item.fileInfo === null || item.fileInfo === "");
  agendaFileList.forEach(element => {
    element.user = userList.find(item => item.id === element.adminUserId);
  });
  const linkList = filedata.filter(item => item.fileInfo !== "" && item.ext === "");

  const handleSave = async (type) => {

    vote.vote = type;

    try {
      if (vote.id) { // guncelleme

        let voteWithoutUser = { ...vote };
        delete voteWithoutUser.user;
        voteWithoutUser.pdate = new Date(); 
        vote.pdate = new Date();
        const result = await putUpdateObjectApi(VOTE, voteWithoutUser);
        if (result.status) {
          window.getSelection?.()?.removeAllRanges?.();
          dispatch(showAgendaSnackbar({ message: 'Oyunuz güncellendi.', severity: 'success' }));

          await buttonTextChange(type);
          setVote(vote);
          setIsDeleteButtonVisible(true);

          updateAfterTable && updateAfterTable({ ...vote })

        }

      } else { // ekleme

        const result = await postSaveObjectApi(VOTE, vote);
        if (result.status) {
          window.getSelection?.()?.removeAllRanges?.();
          dispatch(showAgendaSnackbar({ message: 'Oyunuz kaydedildi.', severity: 'success' }));
          vote.id = result.data.insertId;
          await buttonTextChange(type);
          setVote(vote);
          setIsDeleteButtonVisible(true);

          addAfterTable({ id: result.data.insertId, ...vote });
        }

      }
    } catch (error) {
      console.error('Hata:', error);
    }

    finally {

      if (vote.id !== undefined) {
        const result = await controlOfAllUserInputs(vote.meetingId, "vote");
        if (result.status) {
          if (result.data === 0) {

            // hatırlatıcı varsa silme yapılıyor
            let existingCron = await getObjectListByPropertyApi(CRON_DATA, "meetingId", vote.meetingId);
            existingCron = existingCron.data;
            if (existingCron.length > 0) {
              for (const item of existingCron) {
                await deleteObjectApi(CRON_DATA, item.id); //  cron uyeler oylamasını tamamladıgı icin silindi vote
              }
            }

            dispatch(showAgendaSnackbar({ message: 'Bu toplantıya ait tüm oylar tamamlandı.', severity: 'success' }));

          }
        }
      }

    };

  }
  const buttonTextChange = async (type) => {
    if (type === 1) {
      setAcceptButtonText("Kabul ettiniz")
      setRejectButtonText("Ret")
      setIsDeleteButtonVisible(true);

    } else if (type === 2) {
      setRejectButtonText("Reddettiniz")
      setAcceptButtonText("Kabul")
      setIsDeleteButtonVisible(true);

    } else if (type === 0) {
      setRejectButtonText("Ret")
      setAcceptButtonText("Kabul")
      setIsDeleteButtonVisible(false);

    }

  };

  const handleDeleteItem = async (vote) => {
    const result = await handleDelete(vote)
    if (result.status) {

      window.getSelection?.()?.removeAllRanges?.();
      dispatch(showAgendaSnackbar({ message: 'Oyunuz silindi.', severity: 'success' }));

      setVoteInputStatus(false)
      setVote(emptyVote)
      await buttonTextChange(0)
      setIsDeleteButtonVisible(false)
    }
  };

  const handleChange = name => (e) => {

    setVote({
      ...vote,
      [name]: e.target.value
    })
  }

  const secondTitle = vote.id !== undefined ? (vote.vote === 1 ? "Kabul ettiniz" : vote.vote === 2 ? "Reddettiniz" : "") : "Henüz Oy Vermediniz";

  // Dosyaları grupla
  const groupedData = chunkData(agendaFileList, 5);
  const groupedDataLink = chunkData(linkList, 5);

  return (
    <>
        <Card
          key={index}
          sx={{
            m: 0,
            p: '10px',
            marginBottom: 0,
            minHeight: `${dshCardHeight}`,
            // height: `${dshPreviousCardHeight}`,
          }}
        >
          <DshBoxTitle color="primary" secondTitle={secondTitle} title={`Gündem Maddesi ${decision.decisionNo}` + " / " + getSubjectName(decision.subjectId, subjectList)} />

          <Grid container marginY={2} spacing={1} rowSpacing={1}>
            <Grid item xs={12} md={12} lg={12} >
              <span style={{  }}>
                {decision.agenda.replace(/<[^>]*>?/g, "")}
              </span>
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
              <Typography
                variant={"h6"}
                color={`${redColor}`}
                sx={{  }}
              >
                Karar
              </Typography>
              <span style={{ whiteSpace: "pre-line" }}>
                {/* {decision.decision.replace(/<[^>]*>?/g, "")} */}
                {highlightText(stripHTMLTags(decision.decision), highlightQuery)}
              </span>
            </Grid>

            <Grid
              container
              marginY={2}
              marginX={0}
              spacing={1}
              rowSpacing={1}
            >
              <Grid item xs={10} md={10} lg={10}>
                <TextField
                  variant="outlined"
                  label="Varsa yorum ya da ret gerekçenizi yazınız..."
                  multiline
                  fullWidth
                  rows={4}
                  value={vote.info}
                  onChange={handleChange("info")}
                  InputProps={{
                    style: {  },
                  }}
                  InputLabelProps={{
                    style: {  },
                  }}
                />
              </Grid>

              <Grid
                item
                xs={6}
                md={3}
                lg={2}
                style={{ display: "flex", flexDirection: "column" }}
              >
                <Button
                  variant="contained"
                  fullWidth
                  size='small'
                  color="success"
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={() => handleSave(1)}
                  style={{
                    maxWidth: "70%",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    marginBottom: "5px",
                  }}
                >
                  {acceptButtonText}
                </Button>

                <Button
                  variant="contained"
                  fullWidth
                  size="small" // Prop olarak ekleniyor
                  color="error"
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={() => handleSave(2)}
                  style={{
                    maxWidth: "70%",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    marginBottom: "5px",
                  }}
                >
                  {rejectButtonText}
                </Button>

                {isDeleteButtonVisible && (
                  <Button
                    variant="contained"
                    color="warning"
                    size='small'
                    fullWidth
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={() => handleDeleteItem(vote)}
                    style={{
                      maxWidth: "70%",
                      whiteSpace: "nowrap",
                      size: 'small',

                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      }}
                  >
                    Sil
                  </Button>
                )}
              </Grid>
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
              <ReviewFileListTable groupedData={groupedData} borderType={false} />
            </Grid>

            {groupedDataLink.length > 0 && (
              <Grid item xs={12} md={12} lg={12}>
                <ReviewFileListTable groupedData={groupedDataLink} borderType={false} dataType='link' />
              </Grid>
            )}
          </Grid>
        </Card>
    </>
  );
}
export default AddUpdateVoteCard;

